export default __webpack_public_path__ + "static/media/full-tutorial.cf0701fb.png";